export const REGIONS = {
  OUS: "OUS",
  USA: "USA",
};

export const API_URLS = {
  [REGIONS.OUS]: {
    admin: process.env.REACT_APP_API_BASE_URL,
    motiva: process.env.REACT_APP_MOTIVA_API_BASE_URL,
    warranties: process.env.REACT_APP_WARRANTIES_API_BASE_URL,
  },
  [REGIONS.USA]: {
    admin: process.env.REACT_APP_USA_API_BASE_URL,
    motiva: process.env.REACT_APP_USA_MOTIVA_API_BASE_URL,
    warranties: process.env.REACT_APP_USA_WARRANTIES_API_BASE_URL,
  },
};

export const getApiUrls = (region) =>
  API_URLS[region] ?? API_URLS[REGIONS.OUS];
